import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex h-100 w-100" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "my-auto fw-bold mx-1" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["id"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex h-100 w-100" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "my-auto fw-bold mx-1" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" })
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overflow-hidden", _ctx.singleLine ? 'text-nowrap position-relative': ''])
  }, [
    (_ctx.singleLine && _ctx.firstElementIndex !== 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "gallery-navigator cursor-pointer overflow-hidden text-light d-inline-block position-absolute start-0 top-0 bg-dark",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toLeft())),
          style: _normalizeStyle({'height': _ctx.navigatorHeight + 'px'}),
          id: _ctx.id+'Left'
        }, _hoisted_3, 12, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.singleLine && !_ctx.isAtEnd)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "gallery-navigator cursor-pointer overflow-hidden text-light d-inline-block position-absolute end-0 bg-dark",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toRight())),
          style: _normalizeStyle({'height': _ctx.navigatorHeight + 'px'}),
          id: _ctx.id+'Right'
        }, _hoisted_6, 12, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass((_ctx.singleLine ? 'text-nowrap overflow-hidden ' : 'd-flex flex-wrap') + _ctx.galleryClass),
      id: _ctx.id
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_7)
  ], 2))
}